import { InputBase, Typography, InputAdornment, Box } from "@mui/material";
import React, { useState } from "react";
import { Colors } from "../../Constants/colors";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";
import { FONT_SIZE } from "../../Constants/Enums/styles.enum";

interface Props {
  placeHolder: string;
  value: string | number;
  setValue: (value: string | number) => unknown;
  type?: "number" | "text" | "password" | "email" | "tel" | "url";
  disabled?: boolean;
  defaultValue?: any;
  label?: string;
  multiline?: boolean;
}

export const SearchInput = ({
  placeHolder,
  label,
  value,
  setValue,
  type = "text",
  disabled = false,
  defaultValue = null,
  multiline = false,
}: Props) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;

    const actualValue = type === "number" ? Number(value) : value;

    setValue(actualValue);
  };

  const displayValue = type === "number" ? String(value) : value;

  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      {label && (
        <Typography
          sx={{
            paddingLeft: "5px",
            fontSize: "14px",
            fontWeight: 500,
            marginBottom: "6px",
            color: Colors.DarkGrey,
            fontFamily: FontFamily.ROBOTO_REGULAR,
          }}
        >
          {label}
        </Typography>
      )}
      <Box sx={{ position: "relative" }}>
        <InputBase
          className="rounded-sm"
          sx={{
            ...inputButtonStyle,
            ...(isFocused && focusedStyle),
            ...(disabled && disabledStyle),
          }}
          placeholder={placeHolder}
          value={displayValue}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          type={type}
          disabled={disabled}
          defaultValue={defaultValue}
          multiline={multiline}
          startAdornment={
            <InputAdornment position="start">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              ></Box>
            </InputAdornment>
          }
        />
      </Box>
    </Box>
  );
};

const inputButtonStyle = {
  width: "100%",
  height: "auto",
  padding: "12px 14px",
  border: `2px solid ${Colors.LightGrey}`,
  fontFamily: FontFamily.ROBOTO_REGULAR,
  fontSize: FONT_SIZE.F14,
  color: Colors.Black,
  backgroundColor: Colors.White,
  borderRadius: "8px",
  transition: "all 0.2s ease",
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.04)",
  "&:hover": {
    borderColor: Colors.Midgrey,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.06)",
  },
  "& .MuiInputBase-input": {
    padding: "0 8px",
  },
  "& .MuiInputBase-input::placeholder": {
    color: Colors.Grey,
    opacity: 1,
    fontWeight: 400,
    fontSize: FONT_SIZE.F14,
  },
};

const focusedStyle = {
  borderColor: Colors.DarkGrey,
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
};

const disabledStyle = {
  opacity: 0.5,
  cursor: "not-allowed",
  backgroundColor: Colors.VeryLightGrey,
  borderColor: Colors.LightGrey,
  "&:hover": {
    backgroundColor: Colors.VeryLightGrey,
    borderColor: Colors.LightGrey,
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.04)",
  },
};
